/**
 * Renders v2 or v1 of the login screen based on the redesign flag.
 * See SessionsPageSwitch for the same pattern on the Sessions list.
 */
import React from 'react';
import { useRedesignFlag } from '../../utils/redesignFlag';
import Login   from './Login';
import LoginV2 from './LoginV2';

export default function LoginSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? LoginV2 : Login;
  return <Component {...props} />;
}
